module.exports = __webpack_public_path__ + "static/img/market.4ecc0c55.png";